import { GenericType } from "../base/edl-generic-type.model";

export enum SloState {
    Not_Set = -1,
    Saved_By_Employee = 79,                      // initial
    Submitted_By_Employee = 80,                  // initial complete
    Reviewed_By_Supervisor = 81,                 // update review
    Approved_By_Supervisor = 82,                 // review Complete
    Progress_Updated_By_Employee = 83,           // midyear update
    Progress_Reviewed_By_Supervisor = 84,        // midyear update
    Progress_Approved_By_Supervisor = 85,        // midyear complete
    Completed_By_Employee = 86,                  // finalize
    SLO_Complete = 87,                          //complete
}
export class SloStateTypes {
    public static readonly SavedByEmployee = new GenericType(79, "Saved By Employee");                     // initial
    public static readonly SubmittedByEmployee = new GenericType(80, "Submitted By Employee");                  // initial complete
    public static readonly ReviewedBySupervisor = new GenericType(81, "Reviewed By Supervisor");                 // update review
    public static readonly ApprovedBySupervisor = new GenericType(82, "Approved By Supervisor");                 // review Complete
    public static readonly ProgressUpdatedByEmployee = new GenericType(83, "Progress Updated by Employee");           // midyear update
    public static readonly ProgressReviewedBySupervisor = new GenericType(84, "Progress Reviewed by Supervisor");       // midyear update
    public static readonly ProgressApprovedBySupervisor = new GenericType(85, "Progress Approved by Supervisor");        // midyear complete
    public static readonly CompletedByEmployee = new GenericType(86, "Completed By Employee");                  // finalize
    public static readonly SLOComplete = new GenericType(87, "SLO Complete");                       //complete
    public static RollbackList: Array<GenericType> = [
        SloStateTypes.SavedByEmployee,
        SloStateTypes.SubmittedByEmployee,
        SloStateTypes.ApprovedBySupervisor,
        SloStateTypes.CompletedByEmployee,
        SloStateTypes.SLOComplete]
}